import React, { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

interface RegistroHistorico { id: number; categoria: string; data: string; registro: string; }

const dataBR = (s?: string | null) => (s ? new Date(`${s}T00:00:00`).toLocaleDateString('pt-BR') : '—');
const hoje = () => new Date().toISOString().slice(0, 10);

/**
 * Controle de histórico datado de UMA categoria (ex.: Histórico físico, Rotina
 * sono). Fica logo abaixo do campo-base correspondente: data + registro + botão
 * "Novo Histórico"/"Nova Rotina" + a linha do tempo daquela categoria.
 */
export default function HistoricoCampo({
  alunoId,
  categoria,
  tipo,
}: {
  alunoId: number;
  categoria: string;
  tipo: 'historico' | 'rotina';
}) {
  const [itens, setItens] = useState<RegistroHistorico[]>([]);
  const [data, setData] = useState(hoje());
  const [texto, setTexto] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const rotuloBotao = tipo === 'rotina' ? '+ Nova Rotina' : '+ Novo Histórico';

  const carregar = useCallback(async () => {
    try {
      const { data: d } = await api.get<RegistroHistorico[]>(`/alunos/${alunoId}/historico`, { params: { categoria } });
      setItens(d || []);
    } catch {
      /* silencioso — o campo-base continua utilizável */
    }
  }, [alunoId, categoria]);

  useEffect(() => { carregar(); }, [carregar]);

  const adicionar = async () => {
    if (!texto.trim()) { setErro('Escreva o registro antes de adicionar.'); return; }
    setSalvando(true);
    setErro('');
    try {
      await api.post(`/alunos/${alunoId}/historico`, { categoria, data, registro: texto.trim() });
      setTexto('');
      await carregar();
    } catch (e: any) {
      setErro(e?.response?.data?.message || 'Erro ao adicionar.');
    } finally {
      setSalvando(false);
    }
  };

  const remover = async (id: number) => {
    try {
      await api.delete(`/alunos/${alunoId}/historico/${id}`);
      setItens((xs) => xs.filter((x) => x.id !== id));
    } catch { /* silencioso */ }
  };

  return (
    <div style={{ margin: '4px 0 14px', paddingLeft: 10, borderLeft: '3px solid #e8f0fe' }}>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
        <input
          type="date"
          value={data}
          onChange={(e) => setData(e.target.value)}
          style={{ padding: 6, border: '1px solid #ddd', borderRadius: 6 }}
        />
        <input
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); adicionar(); } }}
          placeholder="O que registrar nesta data…"
          style={{ flex: '1 1 220px', padding: 6, border: '1px solid #ddd', borderRadius: 6 }}
        />
        <button
          type="button"
          onClick={adicionar}
          disabled={salvando}
          style={{ padding: '6px 12px', borderRadius: 6, border: 'none', background: '#2e7d32', color: '#fff', cursor: 'pointer', fontWeight: 600, whiteSpace: 'nowrap' }}
        >
          {salvando ? 'Salvando…' : rotuloBotao}
        </button>
      </div>

      {erro && <div style={{ color: '#c62828', fontSize: 12, marginTop: 4 }}>{erro}</div>}

      {itens.length > 0 && (
        <div style={{ marginTop: 6, display: 'flex', flexDirection: 'column', gap: 3 }}>
          {itens.map((i) => (
            <div key={i.id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 13 }}>
              <span style={{ flex: '0 0 82px', fontWeight: 700, color: '#555' }}>{dataBR(i.data)}</span>
              <span style={{ flex: 1, color: '#333' }}>{i.registro}</span>
              <button type="button" onClick={() => remover(i.id)} title="Remover" style={{ border: 'none', background: 'transparent', color: '#c62828', cursor: 'pointer' }}>✕</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
